<template>
    <v-container class="max-container">
        <v-row cols="12" class="no-pd">
            <v-col xs="12" sm="12" md="6" lg="6" xl="6" :class="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs? 'flex-row-center image--mg-b': 'flex-row-end-start'">
                <v-img class="image" max-height="300" max-width="440" aspect-ratio="2" :src="prizeObject.image? prizeObject.image : 'https://lity-prod.s3-sa-east-1.amazonaws.com/images/LITY_GIFT.gif'" />
            </v-col>

            <v-col xs="12" sm="12" md="6" lg="6" xl="6">
                <div class="text--mg-b">
                    <h3 v-text="prizeObject.title"></h3>
                    <p class="prize_text--color"> {{prizeObject.description}} </p>
                </div>                

                <div class="text--mg-b" v-if="prizeObject.dateExpires !== null">
                    <h4>Expira em</h4>
                    <span class="prize_text--color"> {{ getDateByTimeStamp(prizeObject.dateExpires) + ' ' + getHourByTimeStamp(prizeObject.dateExpires)}} </span>
                </div>

                <div>
                    <div class="flex-col-start">
                        <span class="instruction__number"> Para resgatar siga as instruções: </span>
                        <div class="instruction__text"> <span class="instruction__number"> 1. </span> Leve seus produtos até o caixa </div>
                        <div class="instruction__text"> <span class="instruction__number"> 2. </span> Se identifique no caixa através do CPF </div>
                        <div class="instruction__text"> <span class="instruction__number"> 3. </span> <span class="instruction__text-bold"> Solicite o resgate ao atendente </span> </div>
                    </div>
                    <v-btn class="principal__button" :color="currentCompany.primaryColor" v-if="false">
                        <span class="text-none text-white">Resgatar</span>
                    </v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import moment from "moment";

//Store
import { mapGetters } from "vuex";

//Services
import { getUserPrizeByCompanyIdAndCurrentContactIdAndId } from "./service/prize-detail.service";

export default {
    name: "prizeDetail",
    computed: {
        ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany'
            }
        )
    },
    data: () => ({
        prizeId: null,
        prizeObject: {
            image: '',
            title: "-",
            description: "-",
            discount: '-',
            daysToRedeem: '-'
        },
        instructions: [
            {number: 1, text: ''},
            {number: 2, text: ''},
            {number: 3, text: ''}
        ],
        expireDate: 0
    }),
    created() {
        this.getPrizeId()
    },
    methods: {
        getPrizeId(){
            this.prizeId = this.$route.query.premioId
            this.getPrizeDetailInfo()
        },
        getPrizeDetailInfo() {
            getUserPrizeByCompanyIdAndCurrentContactIdAndId( this.currentCompany.id, this.prizeId )
               .then( success => {
                        this.prizeObject = success.data
                    }
                )
                .catch( error => {
                    if (error != null) {
                            this.$toasted.show(error.message, { type: 'error' } )
                        }
                    }
                )
        },
        getHourByTimeStamp( data ){
            var moment = require('moment')
            var formatted = moment(data).format("HH:mm")
            return formatted
        },
        getDateByTimeStamp( data ){
            var moment = require('moment')
            var formatted =  moment(data).format("DD/MM/YYYY")
            return formatted;
        }
    }
}
</script>

<style scoped>
.text--mg-b {
    margin-bottom: 16px;
}
.prize_text--color {
    color: #858585 !important;
}
.image {
    border-radius: 10px;
}
.image--mg-b {
    margin-bottom: 28px;
}
.instruction__number {
    color: var(--cor--primaria) !important;
    font-size: 16px;
    font-weight: bold;
}
.instruction__text {
    font-size: 14px;
}
.instruction__text-bold {
    font-weight: bold;
}
.expire__date {
    font-weight: bold;
    color: #EE5D09;
    font-family: 'Nunito', sans-serif;
    font-size: 14px;
    margin-top: 8px;
}
</style>